import { Operator } from "@skilitics/judy";

import type { ConditionBuilder, ConditionBuilderContext, DesignerCondition } from "../../../types";
import { createConditionBuildable } from "../../conditions";
import { GROUP_CONDITION_CHILDREN_KEY, NEGATION_CONDITION_NAME } from "../../constants";
import { NegationConditionEditor } from "./NegationConditionEditor";
import { NegationConditionSummary } from "./NegationConditionSummary";

interface Context extends ConditionBuilderContext {
  children: {
    [GROUP_CONDITION_CHILDREN_KEY]: DesignerCondition[];
  };
}

// note: only a single child is permitted but using an array for the
//       moment to plug into the existing response editor infrastructure
export const negationConditionBuilder: ConditionBuilder<Context> = {
  typeId: NEGATION_CONDITION_NAME,
  defaultCategory: "Utility",
  build: ({ children: { values } }) => {
    if (!values.length) return;

    return {
      type: "boolean",
      operator: Operator.EQ,
      subject: {
        type: "boolean",
        resolveType: "condition",
        condition: values[0].build(),
      },
      object: false,
    };
  },
  getInitialChildren: () => ({
    [GROUP_CONDITION_CHILDREN_KEY]: [],
  }),
  views: {
    summary: NegationConditionSummary,
    edit: NegationConditionEditor,
  },
};

export const negationConditionBuildableCreate = () =>
  createConditionBuildable(negationConditionBuilder, NEGATION_CONDITION_NAME, { title: "Flip Result" });
